module.exports = __webpack_public_path__ + "img/fondo4.3b0357cd.png";